import axios from 'axios'

const base = process.env.BASE
const basePath = base + '/api'
const commonPath = base + '/common'

// const token = sessionStorage.getItem("token")

function token() {
  return sessionStorage.getItem('token')
}

function currentUser() {
  return JSON.parse(sessionStorage.getItem('currentUser'))
}

/**
 * 获取一些全局常量 Map [key: UserState.NORMAL, value: 0]
 * @returns {any}
 */
function getGlobalMap() {
  // 此数据都是常量数据, 不需要进行鉴权处理, 如果需要鉴权, 可以使用 /hasAuth 接口
  return JSON.parse(sessionStorage.getItem('globalMap'))
}

/**
 * 权限 Map 获取, 权限判断为 getPermissionMap()['sys:user:add']
 * @returns {any}
 */
function getPermissionMap() {
  // 此数据都是常量数据, 不需要进行鉴权处理, 如果需要鉴权, 可以使用 /hasAuth 接口
  return JSON.parse(sessionStorage.getItem('permissionMap'))
}

const menu = {
  //注册功能获取验证码 common/sendMobileOrEmailCode
  sendMobileOrEmailCode: function(params) {
    return axios.post(commonPath + '/sendMobileOrEmailCode', params)
  },
  //外部企业用户注册  /platform/pc/regExternalOrgUser
  regExternalOrgUser: function(params) {
    return axios.post(base + '/platform/pc/regExternalOrgUser', params)
  },
  //外部个人 /platform/pc/regExternalUser
  regExternalUser: function(params) {
    return axios.post(base + '/platform/pc/regExternalUser', params)
  },
  // checkLoginNameIsExists
  checkLoginNameIsExists: function(params) {
    return axios.post(base + '/platform/pc/checkLoginNameIsExists', params)
  },
  //获取验证码
  getLoginVerifyCode: function() {
    return axios.get(base + '/getLoginVerifyCode')
  },
  commonPathGetOneSysParameter(keyword) {
    return axios.get(commonPath + '/getOneSysParameter/' + keyword)
  },
  //校验账号是否存在
  loginNameIsExist: function(loginName) {
    let params = { loginName: loginName }
    return axios.post(base + '/common/user/loginNameIsExist', params)
  },
  //验证码登录
  login: function(params) {
    let params1 = new URLSearchParams({
      loginName: params.loginName,
      smsCodeLogin: params.smsCodeLogin,
      validateCode: params.validateCode
    })
    return axios.post(base + '/login', params1)
  },
  //获取验证码
  sendVerifyCode: function(params) {
    return axios.post(commonPath + '/verify/sendVerifyCode', params)
  },
  //获取图片验证码
  getImgVerifyCode(params) {
    return (
      base +
      '/getZhVerifyCode?type=' +
      params +
      '&timeStamp=' +
      new Date().getTime()
    )
  },
  //找回密码
  retrievePassword: function(params) {
    return axios.post(commonPath + '/user/retrievePassword', params)
  },
  // 加密解密
  getAesKey: function() {
    return axios.get(base + '/getAesKey')
  },
  //初始化/common/getProjectName
  getProjectName: function() {
    return axios.get(commonPath + '/getProjectName')
  },
  //单点登录
  singleSignOn: function() {
    return axios.get(commonPath + '/login/ssoUmsp')
  },
  // 单个系统参数公共获取方法 /sysConfigs/getOneSysParameter/
  getOneSysParameter(keyword) {
    return axios.get(basePath + '/sysConfigs/getOneSysParameter/' + keyword)
  },

  // 根据级别获取所有菜单集合(不包含有 permission 权限的按钮等菜单), 一般级别不超过 5 级
  menuTreeByLevel: function(level) {
    level = undefined === level ? 5 : level
    return axios.post(basePath + '/menuTreeByLevel/' + level)
  },

  // 根据级别获取当前用户所有菜单集合(不包含有 permission 权限的按钮等菜单), 一般级别不超过 5 级, 此接口可以获取所有按钮等菜单
  menuTreeByUserAndLevel: function(hasPermission, level) {
    level = undefined === level ? 5 : level
    let params = new URLSearchParams({
      hasPermission: undefined === hasPermission ? false : hasPermission
    })
    return axios.post(basePath + '/menuTreeByUserAndLevel/' + level, params)
  },

  // 创建菜单信息
  createMenuInfo: function(menuInfo) {
    return axios.post(basePath + '/createMenuInfo', menuInfo)
  },

  // 根据 ID 删除菜单
  deleteMenuInfo: function(menuId) {
    return axios.post(basePath + '/deleteMenuInfo/' + menuId)
  },

  // 根据 ID 跟新菜单
  updateMenuInfo: function(menuInfo) {
    return axios.post(basePath + '/updateMenuInfo', menuInfo)
  },

  // 获取所有菜单列表并分页
  getMenuListForPage: function(menuInfo) {
    return axios.post(basePath + '/getMenuListForPage', menuInfo)
  },

  // 根据角色 ID 获取所有菜单 ID
  menuIdsByRoleId: function(roleId) {
    return axios.post(basePath + '/menuIdsByRoleId/' + roleId)
  },
  //登录是否有验证码校验
  loginCheckVerifyCode() {
    return axios.get(base + '/loginCheckVerifyCode')
  },
  // 业务办理平台地址返回接口
  toUmspPath() {
    return axios.get(commonPath + '/toUmspPath')
  },
  //业务办理平台单点登录返回接口
  ssoUmsp() {
    return axios.get(commonPath + '/login/ssoUmsp')
  },
  // 获取账号签章权限列表
  getSealAccountList() {
    return axios.post(basePath + '/getOrgUserAccountList')
  },
  // 分中心
  toUess() {
    return axios.get(base + '/new_ftp/loginNewFtpPath')
  },
  //下载客户端 /common/login/downloadClient
  downloadClient() {
    return axios.get(base + '/common/login/downloadClient')
  },
  // 物理用印系统
  physicalSealSystem() {
    return axios.get(base + '/common/login/physicalSealSystem')
  },
  // 获取客服配置
  getKefuSystemConfig () {
    return axios.post(commonPath + '/customerService/getSystemConfig')
  },
  // 获取客服配置链接
  getKefuSystemConfigUrl (params) {
    return axios.post(commonPath + '/customerService/getUrl', params)
  },
}

const org = {
  //获取机构信息 findInnerOrgList
  findInnerOrgList: function(params) {
    return axios.post(basePath + '/findInnerOrgList', params)
  },
  //获取机构 org/getOrgTreeByCurrentUser
  getOrgTreeByCurrentUser: function(p) {
    let filterCusData = p ? p : '0'
    return axios.get(
      basePath + '/org/getOrgTreeByCurrentUser?filterCusData=' + filterCusData
    )
  },
  // 创建机构信息
  createOrgInfo: function(orgInfo) {
    return axios.post(basePath + '/createOrgInfo', orgInfo)
  },

  // 根据机构 ID 机构信息
  selectOrgInfo: function(orgId) {
    return axios.post(basePath + '/selectOrgInfo/' + orgId)
  },
  //根据机构id 获取机构信息
  selectCompanyInfo: function(orgId) {
    return axios.post(basePath + '/selectCompanyInfo/' + orgId)
  },
  // 根据 PDF 文件获取图片
  getImageBytesByPdf: function(imagePage) {
    return axios.post(basePath + '/getImageBytesByPdf', imagePage)
  },

  // 根据父机构和类型查询所有机构信息集合 类型 1: 公司; 2: 部门
  findOrgInfoListByParentId: function(type, parentId) {
    type = undefined === type ? '' : type
    parentId = undefined === parentId ? '' : parentId
    let params = new URLSearchParams({ type: type, parentId: parentId })
    return axios.post(basePath + '/findOrgInfoListByParentId', params)
  },

  // 根据父机构查询父机构及其以下所有企业及部门信息, 并组装成树
  findOrgInfoTreeByParentId: function(parentId) {
    return axios.post(basePath + '/findOrgInfoTreeByParentId/' + parentId)
  },

  // 修改企业邮箱
  chgOrgEmail: function(orgId, email) {
    let params = new URLSearchParams({ email: email })
    return axios.post(basePath + '/chgOrgEmail/' + orgId, params)
  },
  //合同平台内部机构启用停用接口
  EnableOrg: function(orgid, type) {
    var params = {}
    params.orgid = orgid
    params.type = type
    return axios.post(base + '/platform/sysOrg/enableOrg', params)
  },
  //分页查询单位
  queryCompanyByPage(param) {
    return axios.post(
      basePath +
        '/queryCompanyByPage?pageNum=' +
        param.pageNum +
        '&pageSize=' +
        param.pageSize +
        '&type=' +
        param.type +
        '&name=' +
        param.name
    )
  }
}

const certification = {
  //企业资料完善接口
  completeEnterpriseContactInfo: function(params) {
    return axios.post(basePath + '/completeEnterpriseContactInfo', params)
  },
  //企业经办人认证
  enterpriseUserCertificationForUnionPay: function(params) {
    return axios.post(
      basePath + '/enterpriseUserCertificationForUnionPay',
      params
    )
  },
  //企业用户提供对公账号
  enterpriseUserCertificationForBankNo: function(params) {
    return axios.post(
      basePath + '/enterpriseUserCertificationForBankNo',
      params
    )
  },
  //企业用户提交打款金额
  enterpriseUserCertificationForRemit: function(params) {
    return axios.post(basePath + '/enterpriseUserCertificationForRemit', params)
  },
  getInviteOrgInfoByUserId: function(userId) {
    return axios.post(basePath + '/getInviteOrgInfoByUserId/' + userId)
  },
  updateInviteOrgInfo: function(orgInfo) {
    return axios.post(basePath + '/updateInviteOrgInfo', orgInfo)
  },
  /* //查看关联子公司
   getInviteOrgInfoById:function(id){
   return axios.post(basePath + "/getInviteOrgInfoById", id);
   },*/
  // 完善个人用户资料
  completePersonalInfo: function(personalInfo) {
    return axios.post(basePath + '/completePersonalInfo', personalInfo)
  },

  // 更新企业信息
  updateEnterpriseInfo: function(orgInfo) {
    return axios.post(basePath + '/updateEnterpriseInfo', orgInfo)
  },

  /*// 完善企业联系人信息并身份认证
  completeEnterpriseContactInfo: function(orgInfo) {
      return axios.post(basePath + "/completeEnterpriseContactInfo", orgInfo);
  },*/

  // 根据个人信息 ID 删除资料
  deletePersonalInfo: function(personalId) {
    return axios.post(basePath + '/deletePersonalInfo/' + personalId)
  },

  // 根据个人信息 ID 修改资料
  updatePersonalInfo: function(personalInfo) {
    return axios.post(basePath + '/updatePersonalInfo', personalInfo)
  },

  // 银联卡认证
  personalCertificationForUnionPay: function(personalInfo) {
    return axios.post(
      basePath + '/personalCertificationForUnionPay',
      personalInfo
    )
  },

  // 芝麻认证获取 bizNo 与 认证图片
  personalCertificationForSesame: function() {
    return axios.post(basePath + '/personalCertificationForSesame')
  },

  // 查询芝麻认证结果
  getZhiMaCertificationResult: function(bizNo) {
    return axios.post(basePath + '/getZhiMaCertificationResult/' + bizNo)
  },

  // 企业信息认证查询
  findEnterpriseCertification: function(orgAuthInfo) {
    return axios.post(basePath + '/findEnterpriseCertification', orgAuthInfo)
  },
  getOrgInfoPhoto: function(orgid) {
    return axios.post(basePath + '/getOrgInfoPhoto/' + orgid)
  },
  getOrgInfoAuthriodLetter: function(orgid) {
    return axios.post(basePath + '/getOrgInfoAuthriodLetter/' + orgid)
  },
  // 单个企业信息认证查询
  getEnterpriseCertificationById: function(orgAuthId) {
    return axios.post(basePath + '/getEnterpriseCertificationById/' + orgAuthId)
  },

  // 单个企业信息认证删除
  deleteEnterpriseCertificationById: function(orgAuthId) {
    return axios.post(
      basePath + '/deleteEnterpriseCertificationById/' + orgAuthId
    )
  },

  // 企业信息认证修改
  enterpriseCertification: function(orgAuthInfo) {
    return axios.post(
      basePath + '/enterpriseCertificationUnderLine',
      orgAuthInfo
    )
  },
  //解锁企业用户
  unLockedEnterpriseCertification: function(orgAuthInfo) {
    return axios.post(
      basePath + '/unLockedEnterpriseCertification',
      orgAuthInfo
    )
  },
  // 获取个人用户认证信息
  getPersonalInfoByUserId: function(userId) {
    return axios.post(basePath + '/getPersonalInfoByUserId/' + userId)
  }
}

const contractTemplate = {
  getmainTypeList: function() {
    return axios.post(basePath + '/createTemp/mainTypeList')
  },
  createContractMainTypeList: function() {
    return axios.post(basePath + '/createContractMainTypeList')
  },
  startTemp: function(id) {
    let params = new URLSearchParams({ templateId: id })
    return axios.post(basePath + '/updateTempState/start', params)
  },

  stopTemp: function(id) {
    let params = new URLSearchParams({ templateId: id })
    return axios.post(basePath + '/updateTempState/stop', params)
  },

  copyTemplate: function(tempId) {
    return axios.post(basePath + '/copyTemplate/' + tempId)
  },

  createContractTemplate: function(contractTemplateInfo) {
    return axios.post(
      basePath + '/createContractTemplate',
      contractTemplateInfo
    )
  },

  deleteTemplate: function(tempId) {
    return axios.post(basePath + '/deleteTemplate/' + tempId)
  },

  historyTemplateInfo: function(id) {
    return axios.post(basePath + '/historyTemplateInfo/' + id)
  },

  historyTemplateList: function(tempId) {
    return axios.post(basePath + '/historyTemplateList/' + tempId)
  },

  templateInfoCheckName: function(name) {
    let params = new URLSearchParams({ name: name })
    return axios.post(basePath + '/templateInfo/checkName', params)
  },

  variableList: function(tempId) {
    return axios.post(basePath + '/templateInfo/variableList/' + tempId)
  },

  templateInfo: function(tempId) {
    return axios.post(basePath + '/templateInfo/' + tempId)
  },

  templateList: function(name, typeId, pageNum, pageSize) {
    let params = new URLSearchParams({
      name: name,
      typeId: typeId,
      pageNum: pageNum,
      pageSize: pageSize
    })
    return axios.post(basePath + '/templateList', params)
  },

  updateTempState: function(templateId, state) {
    let params = new URLSearchParams({ templateId: templateId, state: state })
    return axios.post(basePath + '/updateTempState', params)
  },

  updateTemplateInfo: function(contractTemplateInfo) {
    return axios.post(basePath + '/updateTemplateInfo', contractTemplateInfo)
  }
}

const dict = {
  //
  getUUID: function() {
    return axios.get(basePath + '/generateUUID')
  },

  // 创建数据字典
  createDictInfo: function(dictInfo) {
    return axios.post(basePath + '/createDictInfo', dictInfo)
  },

  // 根据 ID 删除数据字典
  deleteDictInfo: function(dictId) {
    return axios.post(basePath + '/deleteDictInfo/' + dictId)
  },

  // 获取所有字典名称
  getDictName: function() {
    return axios.post(basePath + '/getDictName')
  },

  // 根据条件获取数据字典集合, 并分页
  dictList: function(dictInfo) {
    return axios.post(basePath + '/dictList', dictInfo)
  },

  // 根据 ID 更新数据字典
  updateDictInfo: function(dictInfo) {
    return axios.post(basePath + '/updateDictInfo', dictInfo)
  }
}

const contractCommon = {
  downloadFileById: function(id, mode) {
    let params = new URLSearchParams({ id: id, mode: mode })
    // console.log(params,"x...查看发送数据");
    return axios.get(basePath + '/contract/common/downloadFileById', params)
  },

  sendMailTest: function() {
    return axios.get(basePath + '/contract/common/sendMailTest')
  },

  testDownFileToFtp: function(filePath, outPath) {
    let params = new URLSearchParams({ filepath: filePath, outPath: outPath })
    return axios.post(basePath + '/contract/common/testDownFileToFtp', params)
  },

  testUploadFileToFtp: function() {
    return axios.post(basePath + '/contract/common/testUploadFileToFtp')
  },

  uploadFile: function(params) {
    // let params = new URLSearchParams({'file': file});
    return axios.post(basePath + '/contract/common/uploadFile', params)
  }
}

const user = {
  //切换机构,并更换token
  changeOrgLogin(params) {
    return axios.post(base + '/changeOrgLogin', params)
  },
  //保存可撤销的角色列表 /contractCancel/saveCancelUserContractRole
  contractCancelSaveCancelUserContractRole(params) {
    return axios.post(
      basePath + '/user/contractCancel/saveCancelUserContractRole',
      params
    )
  },
  //查询可撤销的角色列表/contractCancel/queryByUserId
  contractCancelQueryByUserId(params) {
    return axios.post(basePath + '/user/contractCancel/queryByUserId', params)
  },
  //重置密码 resetPassword
  resetPassword(params) {
    return axios.post(basePath + '/resetPassword', params)
  },
  //添加物理用印审核 contractPhySealAudit/addList
  contractPhySealAuditAdd(params) {
    return axios.post(basePath + '/contractPhySealAudit/addList', params)
  },
  //回显物理用印审核 contractPhySealAudit/contractPhySealAuditList
  contractPhySealAuditList(params) {
    return axios.post(
      basePath + '/contractPhySealAudit/contractPhySealAuditList',
      params
    )
  },
  //授权法人章 获取当前企业下的所有用户列表 getOrgUserByOrgIdList
  getOrgUserByOrgIdList(params) {
    return axios.post(basePath + '/getOrgUserByOrgIdList', params)
  },
  //保存是授权法人 orgLegalAuth/saveOrUpdate
  saveOrUpdateOrgLegalAuth(params) {
    return axios.post(basePath + '/orgLegalAuth/saveOrUpdate', params)
  },
  //查询授权的法人 orgLegalAuth/findByOrgId
  orgLegalAuthFindByOrgId(orgid, userId) {
    return axios.post(
      basePath +
        '/orgLegalAuth/findByOrgId?orgid=' +
        orgid +
        '&userId=' +
        userId
    )
  },
  //删除授权法人 orgLegalAuth/deleteById
  orgLegalAuthDeleteById(id) {
    return axios.post(basePath + '/orgLegalAuth/deleteById?id=' + id)
  },
  // 印章授权 获取机构
  getOrgLegalList() {
    return axios.post(basePath + '/orgLegalAuth/getOrgLegalList')
  },
  //获取待办tabs customPanel/list
  customPanelList: function(params) {
    return axios.post(basePath + '/customPanel/list', params)
  },
  //保存待办设置 customPanel/save
  customPanelSave: function(params) {
    return axios.post(basePath + '/customPanel/save', params)
  },

  //判断实名按钮 /user/checkUserCanAuth
  checkUserCanAuth: function() {
    return axios.post(basePath + '/user/checkUserCanAuth')
  },
  //获取合同类型(自定义合同查询权限)  contractType/getContractTypeSelectList
  getContractTypeSelectList: function() {
    return axios.get(basePath + '/contractType/getContractTypeSelectList')
  },
  //查询用户自定义合同查询权限列表 /userInfo/getUserCusContractSelectDataList/
  getUserCusContractSelectDataList: function(userId) {
    return axios.get(
      basePath + '/userInfo/getUserCusContractSelectDataList/' + userId
    )
  },
  //验证验证码 /common/verify/checkVerifyCode
  checkVerifyCode: function(parmas) {
    return axios.post(commonPath + '/verify/checkVerifyCode', parmas)
  },
  //修改手机号码
  verifyPhoneNum: function(parmas) {
    return axios.post(basePath + '/user/verifyPhoneNum', parmas)
  },
  //修改邮箱号码
  verifyEmail: function(parmas) {
    return axios.post(basePath + '/user/verifyEmail', parmas)
  },
  //修改联系电话
  chgOrgContactPhone: function(params) {
    return axios.post(basePath + '/chgOrgContactPhone', params)
  },
  // 修改个人信息
  perfectUser: function(parmas) {
    return axios.post(basePath + '/perfectUser', parmas)
  },
  chgOrgInfo: function(parmas) {
    return axios.post(basePath + '/chgOrgInfo', parmas)
  },
  //申请印章 api/createUserInfo/applySeal
  applySeal: function(params) {
    // let params = new URLSearchParams({'file': file});
    return axios.post(basePath + '/applySeal', params)
  },
  applySealForOrg: function(params) {
    return axios.post(basePath + '/org/applySeal', params)
  },
  //组织机构->创建管理员  /org/createOrgAdmin
  createOrgAdmin: function(params) {
    return axios.post(basePath + '/org/createOrgAdmin', params)
  },
  applySealForUser: function(params) {
    return axios.post(basePath + '/user/applySeal', params)
  },
  //获取所有用户->用于接收人
  findAllUser: function(name, pageNum, pageSize) {
    //console.log(name);
    let param = new URLSearchParams({
      name: name,
      pageNum: pageNum,
      pageSize: pageSize
    })
    return axios.post(basePath + '/findAllUser', param)
  },
  getInvitation: function(userid) {
    return axios.post(basePath + '/getInvitation?userid=' + userid)
  },
  operataInvitation: function(oResult, orgId) {
    return axios.post(
      basePath + '/operataInvitation?oResult=' + oResult + '&orgId=' + orgId
    )
  },
  receiveRecordYqtContract: function(id) {
    let param = new URLSearchParams({ id: id })
    return axios.post(basePath + '/receiveRecordYqtContract', param)
  },
  getSysParameterhasReceiverSetting: function() {
    return axios.post(basePath + '/getSysParameterhasReceiverSetting')
  },
  // 修改用户密码
  chgPassword: function(oldPassword, newPassword) {
    let param = new URLSearchParams({
      oldPassword: oldPassword,
      newPassword: newPassword
    })
    return axios.post(basePath + '/chgPassword', param)
  },

  // 创建内部用户
  createUserInfo: function(userInfo) {
    return axios.post(basePath + '/createUserInfo', userInfo)
  },
  createOutsidePerson: function(userInfo) {
    return axios.post(basePath + '/createOutUserInfo', userInfo)
  },
  createOutsideCompany: function(userInfo) {
    return axios.post(basePath + '/createOutOrgUserInfo', userInfo)
  },
  // 当前用户信息, 已登入用户可以通过 api.currentUser() 获取缓存用户信息
  currentUserInfo: function() {
    return axios.post(basePath + '/currentUserInfo')
  },

  // 删除内部用户
  deleteUserInfo: function(userId) {
    return axios.post(basePath + '/deleteUserInfo/' + userId)
  },

  // 停用用户
  disableUser: function(userId) {
    return axios.post(basePath + '/disableUser/' + userId)
  },

  // 启用用户
  enableUser: function(userId) {
    return axios.post(basePath + '/enableUser/' + userId)
  },

  // 导出所有用户到 Excel
  exportUser: function() {
    return axios.get(basePath + '/exportUser')
  },

  // 导入用户 Excel 表格信息
  importUserFile: function(file, userInfo) {
    let params = new URLSearchParams({ file: file, userInfo: userInfo })
    return axios.post(basePath + '/importUserFile', params)
  },

  // 锁定用户, 并踢出
  lockUser: function(username) {
    return axios.post(basePath + '/lockUser/' + username)
  },

  // 解锁用户
  unlockUser: function(userId) {
    return axios.post(basePath + '/unlockUser/' + userId)
  },

  // 更新用户信息
  updateUserInfo: function(userInfo) {
    return axios.post(basePath + '/updateUserInfo', userInfo)
  },
  // 更新用户信息 用户管理
  updateUserBaseInfoandLagel: function(userInfo) {
    return axios.post(basePath + '/updateUserBaseInfoandLagel', userInfo)
  },
  // 更新用户信息
  updateRoleAndDataScop: function(userInfo) {
    return axios.post(basePath + '/updateRoleAndDataScop', userInfo)
  },
  // 更新用户信息
  updateDataScop: function(userInfo) {
    return axios.post(basePath + '/updateDataScop', userInfo)
  },
  //合同设置
  updateContractQueryScop: function(userInfo) {
    return axios.post(basePath + '/updateContractQueryScop', userInfo)
  },
  // 根据 ID 获取用户信息
  userInfo: function(userId) {
    return axios.post(basePath + '/userInfo/' + userId)
  },
  //根据id 获取该用户的数据范围
  getUserCusDataScopeList: function(userId) {
    return axios.get(basePath + '/userInfo/getUserCusDataScopeList/' + userId)
  },
  // 根据条件查询用户列表, 并分页
  userInfoList: function(userInfo) {
    return axios.post(basePath + '/userInfoList', userInfo)
  },

  // 获取业务数据来源
  findServiceList: function() {
    return axios.post(basePath + '/findServiceList')
  }
}

const log = {
  // 导出所有系统日志数据
  exportSysLog: function() {
    return axios.get(basePath + '/exportSysLog')
  },

  // 系统日志列表查询
  sysLogListByPage: function(logInfo) {
    return axios.post(basePath + '/sysLogListByPage', logInfo)
  },
  // 用户日志列表查询
  userLogListByPage: function(logInfo) {
    return axios.post(basePath + '/userLogListByPage', logInfo)
  },
  // 合同日志列表查询
  contractLogListByPage: function(logInfo) {
    return axios.post(basePath + '/contractLogListByPage', logInfo)
  },
  // 根据 ID 删除日志
  deleteLogInfoById: function(sysLogId) {
    return axios.post(basePath + '/deleteLogInfoById/' + sysLogId)
  }
}

const contractAuth = {
  getAttachContractByParent: function(contractId) {
    let params = new URLSearchParams({ id: contractId })
    return axios.post(basePath + '/getAttachContractByParent', params)
  },
  contractAuthList: function(userId, pageNum) {
    let params = new URLSearchParams({ pageNum: pageNum })
    return axios.get(basePath + '/contractAuthList/' + userId, params)
  }
}

const coduRule = {
  findList: function(codeName, typeId) {
    let params = new URLSearchParams({ codeName: codeName, typeid: typeId })
    return axios.post(basePath + '/coderule/findList', params)
  },

  codeRuleInfo: function(codeId) {
    return axios.post(basePath + '/coderuleInfo/' + codeId)
  },
  codeRuleItemList: function(codeId) {
    return axios.post(basePath + '/coderuleItemList/' + codeId)
  },

  createCodeRule: function(yqtCodeRule) {
    return axios.post(basePath + '/createCodeRule', yqtCodeRule)
  },

  deleteCodeRule: function(codeId) {
    return axios.post(basePath + '/deleteCodeRule/' + codeId)
  },

  updateCodeRule: function(yqtCodeRule) {
    return axios.post(basePath + '/upodateCodeRule', yqtCodeRule)
  }
}
const contract = {
  //待其他人处理合同列表
  findWaitOtherHandlerContractListPage(params) {
    return axios.post(basePath + '/findWaitOtherHandlerContractListPage', params)
  },
  // 查看签署流程
  showSignProcess(params) {
    return axios.post(basePath + '/showSignProcess', params)
  },
  // 修改合同签约人
  updateSubscriberSet: function(params) {
    return axios.post(basePath + '/updateSubscriberSet', params)
  },
  // 获取合同签约人设置
  getSubscriberSet: function(params) {
    return axios.post(basePath + '/getSubscriberSet', params)
  },
  countContractToSign: function(yqtContract) {
    return axios.post(basePath + '/countContractToSign', yqtContract)
  },
  countHasSignedOfBacthSubscriber: function(yqtContract) {
    var params1 = {}
    params1.subIdList = yqtContract
    return axios.post(basePath + '/countHasSignedOfBacthSubscriber', params1)
  },
  //重新提交reSubmitContract
  reSubmitContract(id) {
    return axios.post(basePath + '/reSubmitContract/' + id)
  },
  //提交之前校验
  checkContractIsSubmit(id) {
    return axios.post(basePath + '/checkContractIsSubmit/' + id)
  },
  //物理用印审核列表
  findPhyContractToAudit(params) {
    return axios.post(basePath + '/findPhyContractToAudit', params)
  },
  //审核流程列表
  getAuditListByPhyContractId(contractId) {
    let params = new URLSearchParams({ contractId: contractId })
    return axios.post(basePath + '/getAuditListByPhyContractId', params)
  },
  //授权物理用印审核contract/authPhysicalSeal
  authPhysicalSeal(id) {
    return axios.get(basePath + '/contract/authPhysicalSeal/' + id)
  },
  phyAuditHistory: function(contractId) {
    let params = new URLSearchParams({ id: contractId })
    return axios.post(basePath + '/phyAuditHistory', params)
  },
  //保存审核
  auditPhycontract: function(id, auditReason, auditResult) {
    let params = new URLSearchParams({
      id: id,
      auditReason: auditReason,
      auditResult: auditResult
    })
    return axios.post(basePath + '/auditPhycontract', params)
  },
  //级联查询合同类型列表
  findMainListInStatusList: function() {
    return axios.post(basePath + '/findMainListInStatusList')
  },
  // 根据编号查询自定义数据列表 dataColumn/list
  dataColumnList: function(params) {
    return axios.post(basePath + '/dataColumn/list', params)
  },
  // 电子用印
  changePhysicalSigningContractState(params) {
    return axios.post(
      basePath + '/contract/changePhysicalSigningContractState/' + params
    )
  },
  //物理用印  /contract/changePhysicalSignContractState/{contractId}
  changePhysicalSignContractState: function(contractId) {
    return axios.post(
      basePath + '/contract/changePhysicalSignContractState/' + contractId
    )
  },
  //根据合同id查询 主合同 或者 附属合同 getContractListByContractId
  getContractListByContractId(contractId) {
    return axios.get(
      basePath + '/contract/getContractListByContractId/' + contractId
    )
  },
  //根据合同id获取附属合同 /contract/getChildContractByMainId/{contractId}
  getChildContractByMainId(contractId) {
    return axios.get(
      basePath + '/contract/getChildContractByMainId/' + contractId
    )
  },
  //根据附属合同类型 获取编号 getCodeByTypeId
  getCodeByTypeId: function(typeId) {
    return axios.get(basePath + '/contract/getCodeByTypeId/' + typeId)
  },
  //根据主合同类型获取附属合同类型 getChildContractTypeByMainTypeId
  getChildContractTypeByMainTypeId(typeid) {
    return axios.get(
      basePath + '/contract/getChildContractTypeByMainTypeId/' + typeid
    )
  },
  //根据取附属合同类型获取附属合同模板   getChildTemplateByChildTypeId?pageNum=1&pageSize=10&typeId=4D08BC7FAC8046C49F1EAF94DF6DECC9
  getChildTemplateByChildTypeId(pageInfo) {
    return axios.get(
      basePath +
        `/contract/getChildTemplateByChildTypeId?pageNum=${
          pageInfo.pageNum
        }&pageSize=${pageInfo.pageSize}&typeId=${pageInfo.typeId}`
    )
  },
  //批量创建合同保存 /contract/saveBatchImportContract
  saveBatchImportContract(params) {
    return axios.post(basePath + '/contract/saveBatchImportContract', params)
  },
  //批量创建合同 contract/initBatchImportData/{templateId}
  initBatchImportData: function(templateId) {
    return axios.get(basePath + '/contract/initBatchImportData/' + templateId)
  },
  //根据撤销id获取签约人
  getSubscriberListByRevocationRecordId: function(revocationId) {
    return axios.get(
      basePath + '/getSubscriberListByRevocationRecordId/' + revocationId
    )
  },
  //根据合同ID获取合同撤销记录列表
  getRevocationRecordByContractId: function(contractId) {
    return axios.get(
      basePath + '/getRevocationRecordByContractId/' + contractId
    )
  },
  //重新编辑功能获取签约人
  getSubscriberList: function(contractId) {
    // let params = new URLSearchParams({'contractId': contractId});
    return axios.get(basePath + '/getSubscriberList/' + contractId)
  },
  //待办页面 -> 获取待签章数据
  findContractToSign: function(yqtContract) {
    return axios.post(basePath + '/findContractToSign', yqtContract)
  },
  // 待设置合同
  findContractToSite: function(contract) {
    return axios.post(basePath + '/findContractToSite', contract)
  },
  // 待设置提交
  siteContract: function(contract, codeuuid) {
    return axios.post(
      basePath +
        '/contract/submitSubSignPos/' +
        contract +
        '?codeuuid=' +
        codeuuid
    )
  },
  // 待签章页面内提交
  /*saveSubSignpos: function(contract) {
      return axios.post(basePath + "/saveSubSignpos", contract);
  },*/
  // 提交签章
  saveSubSignpos: function(contract) {
    return axios.post(basePath + '/contract/saveSubSignpos', contract)
  },
  updateSubSignPos: function(contract) {
    return axios.post(basePath + '/contract/updateSubSignPos', contract)
  },
  //待办页面 -> 获取审核数据
  findContractToAudit: function(yqtContract) {
    return axios.post(basePath + '/findContractToAudit', yqtContract)
  },
  //批量签章功能 -> 批量校验合同签约人接口
  checkHasSignedOfBacthSubscriber: function(params) {
    var params1 = {}
    params1.contractIdList = params
    return axios.post(basePath + '/checkHasSignedOfBacthSubscriber', params1)
  },
  //批量签章功能 -> 批量签章计算合同hash接口
  countBatchPdfHash: function(params) {
    return axios.post(basePath + '/countBatchPdfHash', params)
  },
  //批量签章功能 -> 批量签章合并签名
  startBatchPdfMerge: function(params) {
    return axios.post(basePath + '/startBatchPdfMerge', params)
  },
  //获取业务数据项合同变量值
  getContractBusinessVariables: function(contractId, typeid) {
    return axios.post(
      basePath +
        '/getContractBusinessVariables?contractId=' +
        contractId +
        '&contractTypeId=' +
        typeid
    )
  },
  //合同导出
  exportContract: function(params) {
    return axios.post(
      basePath + '/export/contract',
      params,
      { 'Conten-Type': 'application/octet-stream' },
      { responseType: 'blob' }
    )
  },
  //合同催办
  hasten: function(id) {
    return axios.post(basePath + '/contract/hasten/' + id)
  },
  //合同查询->业务数据列表
  queryParameters: function(type) {
    let params = {
      type
    }
    return axios.post(basePath + '/businessitem/queryParameters', params)
  },
  selectContractStatistics: function(params) {
    return axios.post(basePath + '/selectContractStatistics', params)
  },

  findContractDaiGuiDang: function(params) {
    return axios.post(basePath + '/findContractDaiGuiDang', params)
  },
  getContractNum: function() {
    return axios.post(basePath + '/getContractAmountByState')
  },
  addInvalidContract: function(contractId) {
    return axios.post(basePath + '/addInvalidContract/' + contractId)
  },
  auditYqtcontract: function(id, auditReason, auditResult) {
    let params = new URLSearchParams({
      id: id,
      auditReason: auditReason,
      auditResult: auditResult
    })
    return axios.post(basePath + '/auditYqtcontract', params)
  },

  cancelContract: function(id, cancelReason) {
    let params = new URLSearchParams({ id: id, cancelReason: cancelReason })
    return axios.post(basePath + '/cancelYqtcontract', params)
  },

  // 合同查询 撤销
  queryCancelYqtcontract :function(id, cancelReason){
    let params = new URLSearchParams({ id: id, cancelReason: cancelReason })
    return axios.post(basePath + '/queryCancelYqtcontract', params)
  },
  checkContractCode: function(code, contractId) {
    let params = new URLSearchParams({ code: code, contractId: contractId })
    return axios.post(basePath + '/checkContractCode', params)
  },

  findContractAtSigning: function(test) {
    //在签合同列表
    return axios.post(basePath + '/findContractAtSigning', test)
  },

  copyContract: function(id) {
    let params = new URLSearchParams({ id: id })
    return axios.post(basePath + '/copyContract', params)
  },
  deleteContract: function(id) {
    let params = new URLSearchParams({ id: id })
    return axios.post(basePath + '/deleteEditingContract', params)
  },

  daiGuiDangContract: function(code, name, typeId, pageNum, pageSize) {
    let params = new URLSearchParams({
      code: code,
      name: name,
      typeId: typeId,
      pageNum: pageNum,
      pageSize: pageSize
    })
    return axios.post(basePath + '/daiGuiDangYqtContract', params)
  },

  findListInStatusList: function() {
    return axios.post(basePath + '/findListInStatusList')
  },

  findContractToDo: function(yqtContract) {
    return axios.post(basePath + '/findContractToDo', yqtContract)
  },

  findContractAllStatus: function(findContract) {
    return axios.post(basePath + '/findContractAllStatus', findContract)
  },
  findContractYiGuiDang: function(findContract) {
    return axios.post(basePath + '/findContractYiGuiDang', findContract)
  },
  getAuditListByContractId: function(contractId) {
    let params = new URLSearchParams({ contractId: contractId })
    return axios.post(basePath + '/getAuditListByContractId', params)
  },
  auditHistory: function(contractId) {
    let params = new URLSearchParams({ id: contractId })
    return axios.post(basePath + '/auditHistory', params)
  },
  getAuditUserList: function(pageNum, pageSize, name) {
    let params = new URLSearchParams({
      pageNum: pageNum,
      pageSize: pageSize,
      name: name
    })
    return axios.post(basePath + '/getAuditUserList', params)
  },

  getContractBaseInfo: function(contractId, templateId) {
    let params = new URLSearchParams({
      contractId: contractId,
      templateId: templateId
    })
    return axios.post(basePath + '/getContractBaseInfo', params)
  },

  getContractPermission: function(userId, pageNum, pageSize) {
    let params = new URLSearchParams({
      userId: userId,
      pageNum: pageNum,
      pageSize: pageSize
    })
    return axios.post(basePath + '/getContractPermission', params)
  },

  getContractVariableInfoList: function(contractId, templateId) {
    let params = new URLSearchParams({
      contractId: contractId,
      templateId: templateId
    })
    return axios.post(basePath + '/getContractVariableInfoList', params)
  },

  getEditingContractList: function(code, name, typeId, pageNum, pageSize) {
    let params = new URLSearchParams({
      code: code,
      name: name,
      typeId: typeId,
      pageNum: pageNum,
      pageSize: pageSize
    })
    return axios.post(basePath + '/getEditingContractList', params)
  },

  getRecordedContractInfo: function(id) {
    let params = new URLSearchParams({ id: id })
    return axios.post(basePath + '/getRecordedContractInfo', params)
  },

  getRecordedContractList: function(
    code,
    name,
    typeId,
    pageNum,
    pageSize,
    msg
  ) {
    let params = new URLSearchParams({
      code: code,
      name: name,
      typeId: typeId,
      pageNum: pageNum,
      pageSize: pageSize,
      hasReceiverSetting: msg
    })
    return axios.post(basePath + '/getRecordedContractList', params)
  },
  getReceiveRecordedContractList: function(
    code,
    name,
    typeId,
    pageNum,
    pageSize
  ) {
    let params = new URLSearchParams({
      code: code,
      name: name,
      typeId: typeId,
      pageNum: pageNum,
      pageSize: pageSize
    })
    return axios.post(basePath + '/getReceiveRecordedContractList', params)
  },
  getSignObjListByTemplateId: function(templateId) {
    let params = new URLSearchParams({ templateId: templateId })
    return axios.post(basePath + '/getSignObjListByTemplateId', params)
  },

  getSignContactList: function(
    pageNum,
    pageSize,
    name,
    userType,
    type,
    personType
  ) {
    let persontype = userType == '3' ? personType : ''
    let params = new URLSearchParams({
      pageNum: pageNum,
      pageSize: pageSize,
      name: name,
      usertype: userType,
      type: type,
      personType: persontype
    })
    return axios.post(basePath + '/getSigncontactList', params)
  },
  getSubscriberListByContractId: function(contractId) {
    let params = new URLSearchParams({ contractId: contractId })
    return axios.post(basePath + '/getSubscriberListByContractId', params)
  },

  getSubscriberListByTemplateId: function(templateId) {
    let params = new URLSearchParams({ templateId: templateId })
    return axios.post(basePath + '/getSubscriberListByTemplateId', params)
  },

  getTemplateListByParentId: function(templateId) {
    let params = new URLSearchParams({ templateId: templateId })
    return axios.post(basePath + '/getTemplateListByParentId', params)
  },
  templateListByParent: function(id) {
    return axios.post(basePath + '/templateListByParent/' + id)
  },
  getTemplateListByTypeId: function(typeId) {
    let params = new URLSearchParams({ typeId: typeId })
    return axios.post(basePath + '/getTemplateListByTypeId', params)
  },
  guiDangContract: function(id, fileArea, fileDate) {
    let params = new URLSearchParams({
      id: id,
      fileDate: fileDate,
      fileArea: fileArea
    })
    return axios.post(basePath + '/guiDangYqtContract', params)
  },

  guiDangContractCheck: function(id) {
    let params = new URLSearchParams({ id: id })
    return axios.post(basePath + '/guiDangYqtContractCheck', params)
  },

  modifyOrUpdateContractPermission: function(userId, orgTypeInfo) {
    // console.log(orgTypeInfo,Object.prototype.toString.call(orgTypeInfo));
    var test = JSON.stringify(orgTypeInfo)
    let params = new URLSearchParams({ userid: userId, qtSysOrgTypeStr: test })
    return axios.post(basePath + '/modifyOrUpdateContractPermission', params)
  },

  saveContract: function(contractInfo) {
    return axios.post(basePath + '/saveContract', contractInfo)
  },

  saveInvalidContract: function(dataMap) {
    return axios.post(basePath + '/saveInvalidContract', dataMap)
  },

  saveRecordedContractList: function(contractInfo) {
    // let params = new URLSearchParams({'contract': contractInfo});
    return axios.post(basePath + '/saveRecordedContractList', contractInfo)
  },

  submitContract: function(id) {
    return axios.post(basePath + '/submitContract/' + id)
  },

  updateEditingContractState: function(id) {
    let params = new URLSearchParams({ id: id })
    return axios.post(basePath + '/updateEditingContractState', params)
  },

  viewContractInfo: function(contractId) {
    return axios.post(basePath + '/viewContractInfo/' + contractId)
  },
  //补签合同
  ContractSupplement: function(params) {
    //let params = new URLSearchParams({'contractId': contractId, 'subscriberIdList': subscriberIdList});

    return axios.post(basePath + '/contract/retroactive', params)
  },

  yiGuiDangContract: function(code, name, typeId, pageNum, pageSize) {
    let params = new URLSearchParams({
      code: code,
      name: name,
      typeId: typeId,
      pageNum: pageNum,
      pageSize: pageSize
    })
    return axios.post(basePath + '/yiGuiDangYqtContract', params)
  },

  verifySign: function(id) {
    let params = new URLSearchParams({ id: id })
    return axios.post(basePath + '/yqtVerifySign', params)
  },
  //归档区域
  guiDangArea() {
    return axios.post(basePath + '/dictByName/file_area')
  },

  //获得子节点
  setContractSignFlowNodes: function(id) {
    return axios.get(basePath + '/setContractSignFlowNodes/' + id)
  },
  setContractSignFlowNodesSave: function(params) {
    return axios.post(basePath + '/setContractSignFlowNodes/save', params)
  },

  //根据子流程ID复制一份子流程数据
  initSignFlowData: function(id) {
    return axios.get(basePath + '/signFlow/initSignFlowData/' + id)
  },
  //该接口用于设置合同签约人时，查询供选择的签约人数据
  getOrgContracts: function(id) {
    return axios.get(
      basePath + '/setContractSignFlowNodes/getOrgContracts/' + id
    )
  },
  getPersonContracts: function(contractId, name, pageNum, pageSize) {
    let params = new URLSearchParams({
      contractId: contractId,
      name: name,
      pageNum: pageNum,
      pageSize: pageSize
    })
    return axios.post(
      basePath + '/setContractSignFlowNodes/getPersonContracts',
      params
    )
  },
  //撤销签章
  cancelSignFlow: function(id) {
    return axios.post(basePath + '/contract/cancelSignFlow/' + id)
  }
}

const syncUser = {
  // 启 / 停用外部用户 0: 启用; 2: 停用
  revStop: function(userState, username, serviceId) {
    let params = new URLSearchParams({
      username: username,
      serviceId: serviceId
    })
    return axios.post(basePath + '/revStop/' + userState, params)
  },

  // 同步外部用户
  syncUser: function(controlsBo) {
    return axios.post(basePath + '/syncUser', controlsBo)
  },

  // 更新外部用户
  updateUser: function(userBo) {
    return axios.post(basePath + '/updateUser', userBo)
  },
  /*//内容用户
   findInnerUserList:function(){
   return axios.post(basePath + "/findInnerUserList")
   }*/
  findInnerUserListByPage: function(info) {
    return axios.post(basePath + '/findInnerUserListByPage', info)
  },
  findContractByCode: function(params) {
    return axios.post(basePath + '/findContractByCode', params)
  },
  updateContractAccreditSetSubscriber: function(params) {
    return axios.post(basePath + '/updateContractAccreditSetSubscriber', params)
  }
}

const role = {
  // 根据用户类型 获取角色
  getRolesByCurrentUser: function(params) {
    return axios.post(basePath + '/getRolesByCurrentUser', params)
  },
  // 创建角色信息
  createRoleInfo: function(roleInfo) {
    return axios.post(basePath + '/createRoleInfo', roleInfo)
  },

  // 根据 ID 删除角色信息
  chgRoleStatus: function(roleId, status) {
    let params = new URLSearchParams({ status: status })
    return axios.post(basePath + '/chgRoleStatus/' + roleId, params)
  },

  // 获取所有角色信息集合
  roleList: function() {
    return axios.post(basePath + '/roleList')
  },

  // 获取所有角色信息集合并分页
  roleListForPage: function(roleInfo) {
    return axios.post(basePath + '/roleListForPage', roleInfo)
  },

  // 获取当前登入用户的角色信息集合并分页
  getRoleListByUserId: function(userId) {
    return axios.post(basePath + '/getRoleListByUserId/' + userId)
  },

  // 根据用户 ID 获取角色集合
  roleListByUser: function(roleInfo) {
    return axios.post(basePath + '/roleListByUser', roleInfo)
  },

  // 根据 ID 修改角色信息
  updateRoleInfo: function(roleInfo) {
    return axios.post(basePath + '/updateRoleInfo', roleInfo)
  }
}

const contractType = {
  //获取项目列表 xiao_2019_04_24
  projectList: function(pageNum, pageSize, name, excludeProjectIds, status) {
    let params = new URLSearchParams({
      pageNum: pageNum,
      pageSize: pageSize,
      projname: name,
      excludeProjectIds: excludeProjectIds,
      status: status
    })
    return axios.post(basePath + '/projectList', params)
  },
  //根据项目Id获取 项目名称
  getProjectInfo: function(id) {
    return axios.post(basePath + '/getProjectInfo/' + id)
  },
  checkNameIsExist: function(id, name) {
    let params = new URLSearchParams({ id: id, name: name })
    return axios.post(basePath + '/checkNameIsExist', params)
  },
  contractTyeList: function(pageNum, pageSize, name) {
    let params = new URLSearchParams({
      pageNum: pageNum,
      pageSize: pageSize,
      name: name
    })
    return axios.post(basePath + '/contractTyeList', params)
  },

  contractType: function(id) {
    return axios.post(basePath + '/contractType/' + id)
  },
  childTypeList: function(id) {
    let params = new URLSearchParams({ typeid: id })
    return axios.post(basePath + '/createTemp/childTypeList', params)
  },
  copyContractType: function(id) {
    return axios.post(basePath + '/copyContractType/' + id)
  },

  createContractType: function(contractTypeInfo) {
    return axios.post(basePath + '/createContractType', contractTypeInfo)
  },

  deleteContractType: function(id) {
    return axios.post(basePath + '/deleteContractType/' + id)
  },

  editContractType: function(contractTypeInfo) {
    return axios.post(basePath + '/editContractType', contractTypeInfo)
  },

  getContractTypeList: function(fileNature, parentId, status) {
    let params = new URLSearchParams({
      fileNature: fileNature,
      parentId: parentId,
      status: status
    })
    return axios.post(basePath + '/getContractTypeList', params)
  },

  getSignObjListByTypeId: function(typeId) {
    let params = new URLSearchParams({ typeId: typeId })
    return axios.post(basePath + '/getSignObjListByTypeId', params)
  },

  signingObject: function(id) {
    // let params = new URLSearchParams({'id': id});
    return axios.post(basePath + '/signingObject/' + id)
  },

  startContractTy: function(id) {
    let params = new URLSearchParams({ id: id })
    return axios.post(basePath + '/startContractType', params)
  },
  stopContractTy: function(id) {
    let params = new URLSearchParams({ id: id })
    return axios.post(basePath + '/stopContractType', params)
  },
  getSubProcess: function(info) {
    return axios.post(basePath + '/signFlow/querySignFlowListByPage', info)
  }
}
const sms = {
  sendSmsCode: function(params) {
    return axios.post(commonPath + '/sms/sendSmsCode', params)
  },
  checkSmsCode: function(params) {
    return axios.post(commonPath + '/sms/checkSmsCode', params)
  }
}
const contractSign = {
  // isCheckPackage 是否校验
  checkHasSignedOfSubscriber: function(id, isCheckPackage = '0') {
    let params = new URLSearchParams({ id: id, isCheckPackage: isCheckPackage })
    return axios.post(basePath + '/checkHasSignedOfSubscriber', params)
  },

  getSignImageList: function(Cert, sealType, isLegalAuth) {
    let data = new URLSearchParams({
      Cert: Cert,
      sealType: sealType,
      isLegalAuth: isLegalAuth || ''
    })
    return axios.post(basePath + '/getSignImageList', data)
  },

  getMoulageImage: function(type, text) {
    var params = {}
    params.type = type
    params.text = text
    return axios.post(basePath + '/getMoulageImage', params)
  },

  countPdfHashMultiSeal: function(params) {
    return axios.post(basePath + '/countPdfHashMultiSeal', params)
  }
}
const orgManagement = {
  /**
   * @description 获取组织机构树信息
   * @param orgtype 组织机构类型
   * @param name 组织机构名称
   * @param parentId 父级组织机构ID
   * @param isTree 是否是树结构
  */
  getOrgList: function(params) {
    return axios.post(basePath + '/queryOrgInfoTree', params)
  },
  //组织机构树 获取第一层数据
  getOrgInfoTreeFirst: function(params) {
    return axios.post(basePath + '/getOrgInfoTreeFirst', params)
  },
  getOrgInfoList: function(params) {
    return axios.post(basePath + '/getOrgInfoList', params)
  },
  //获取机构子节点 getOrgInfoNextLayer
  getOrgInfoNextLayer: function(id) {
    var param = { id: id }
    return axios.post(basePath + '/getOrgInfoNextLayer', param)
  },
  getOrgInfoTree: function(name) {
    var param = {}
    if (name) {
      param.name = name
    }
    return axios.post(basePath + '/getOrgInfoTree', param)
  },
  // 授权管理
  findAllOrgTree: function(param) {
    var param = {}
    if (name) {
      param.name = name
    }
    return axios.post(basePath + '/crcc16/findAllOrgTree', param)
  },
  findAllOrgNewTree() {
    var param = {}
    return axios.post(basePath + '/crcc16/findAllOrgNewTree', param)
  },
  findUserByOrgId: function(params) {
    return axios.post(basePath + '/crcc16/findUserByOrgId', params)
  },
  getOrgAllUsers: function(params) {
    return axios.post(basePath + '/crcc16/getOrgAllUsers', params)
  },
  // 添加授权人员
  saveCRCC16User: function(params) {
    return axios.post(basePath + '/crcc16/saveCRCC16User', params)
  },
  // 授权角色查询
  findUserRole: function(params) {
    return axios.post(basePath + '/crcc16/findUserRole', params)
  },
  // 授权角色
  saveCRCC16UserRole: function(params) {
    return axios.post(basePath + '/crcc16/saveCRCC16UserRole', params)
  },
  getChildrenByOrg: function(params) {
    return axios.post(basePath + '/crcc16/getChildrenByOrg', params)
  },
  getUsrByOrg: function(params) {
    return axios.post(basePath + '/crcc16/getUsrByOrg', params)
  },
  getOrgnizationTreeByparentId: function(name, orgtype) {
    var param = {}
    if (name) {
      param.name = name
    }
    if (orgtype) {
      param.orgtype = orgtype
    }
    return axios.post(basePath + '/getOrgInfoTreeOne', param)
  },
  selectOrgInfo: function(id) {
    return axios.post(basePath + '/selectOrgInfo/' + id)
  },
  addInviteOrgInfo: function(params) {
    return axios.post(basePath + '/addInviteOrgInfo', params)
  },
  addOrgInfo: function(params) {
    return axios.post(basePath + '/addOrgInfo', params)
  },
  deleteOrgInfo: function(id) {
    return axios.post(basePath + '/deleteOrgInfo/' + id)
  },
  chgOrgEmail: function(
    id,
    email,
    certificatenumber,
    name,
    isInternalSignature,
    type
  ) {
    name = encodeURIComponent(name)
    return axios.post(
      basePath +
        '/chgOrgEmail/' +
        id +
        '?email=' +
        email +
        '&certificatenumber=' +
        certificatenumber +
        '&name=' +
        name +
        '&isInternalSignature=' +
        isInternalSignature +
        '&type=' +
        type
    )
  },
  chgOrgType: function(params) {
    return axios.post(
      basePath + '/chgOrgType/' + params.id + '?orgtype=' + params.orgtype
    )
  },
  getCurrentOrgUserList(params) {
    return axios.post(basePath + '/getCurrentOrgUserList', params)
  },
  getOrgUserList(params) {
    return axios.post(basePath + '/orgUserList', params)
  },
  selectOrgInfoList(name, type) {
    var param = {}
    if (name) {
      param.name = name
    }
    if (type) {
      param.type = type
    }
    return axios.post(basePath + '/selectOrgInfoList', param)
  },
  getInviteOrgInfoByOrgId(id) {
    return axios.post(basePath + '/getInviteOrgInfoByOrgId/' + id)
  }
}
const sysConfig = {
  creates: function(params) {
    return axios.post(basePath + '/sysConfigs/create', params)
  },
  deletes: function(id) {
    return axios.post(basePath + '/sysConfigs/delete/' + id)
  },
  updates: function(params) {
    return axios.post(basePath + '/sysConfigs/update', params)
  },
  selects: function(params) {
    return axios.post(basePath + '/sysConfigs/selectByPage', params)
  },
  getServerBaseUrl: function() {
    return axios.get(basePath + '/sysConfigs/getServerBaseUrl')
  }
}
const businessItem = {
  management: function(params) {
    return axios.post(basePath + '/businessitem/management', params)
  },
  addBusinessItem: function(params) {
    return axios.post(basePath + '/addBusinessItem', params)
  },
  updateBusinessItem: function(params) {
    return axios.post(basePath + '/updateBusinessItem', params)
  }
}
const batch = {
  //批量功能新接口
  getContractTypeList: function() {
    return axios.post(basePath + '/batch/getContractTypeList')
  },
  queryUserGroup: function(info) {
    //let data = new URLSearchParams({'name': name, 'pageNum': pageNum , "pageSize" : pageSize});
    return axios.post(basePath + '/userGroup/queryUserGroupByPage', info)
  },
  getContractBaseInfoByTemplateId: function(templateId) {
    return axios.post(
      basePath + '/batch/getContractBaseInfoByTemplateId/' + templateId
    )
  },
  getTemplateListByTypeId: function(typeId) {
    return axios.post(basePath + '/batch/getTemplateListByTypeId/' + typeId)
  },
  batchSaveContract: function(contractInfo) {
    return axios.post(basePath + '/batch/batchSaveContract', contractInfo)
  },
  getContractBaseInfoByContractId: function(contractId) {
    return axios.post(
      basePath + '/batch/getContractBaseInfoByContractId/' + contractId
    )
  },
  isReviewCompleted: function(contractId) {
    return axios.post(basePath + '/batch/isReviewCompleted/' + contractId)
  },
  toSign: function(contractId) {
    return axios.post(basePath + '/batch/toSign/' + contractId)
  },

  // 批量待办合同查询
  findBatchContractToDo: function(contract) {
    return axios.post(
      basePath + '/batch/findWaitBatchContractForPage',
      contract
    )
  },
  // 批量合同查询 (综合查询, 需要判断合同查询权限)
  findBatchContractAllStatus: function(contract) {
    return axios.post(
      basePath + '/batch/findBatchContractAllStatusForPage',
      contract
    )
  },
  // 获取批量在编合同列表
  getBatchEditingContractList: function(contract) {
    return axios.post(
      basePath + '/batch/getBatchEditingContractForPage',
      contract
    )
  },
  // 批量待办合同中点击签章按钮查询当前用户可以签章的批量子合同
  findBatchSignContractToDo: function(contract) {
    console.log(contract)
    return axios.post(
      basePath + '/batch/findBatchSignChildContractForPage',
      contract
    )
  },

  //合同查询->查看
  getChildContractByBatchId: function(batchId) {
    return axios.post(basePath + '/batch/getChildContractByBatchId/' + batchId)
  },

  getArchivedChildContractByBatchId: function(batchId) {
    return axios.post(
      basePath + '/batch/getArchivedChildContractByBatchId/' + batchId
    )
  },
  //批量归档
  toArchiveContract: function(filingData) {
    let params = new URLSearchParams({
      contractIds: filingData.contractIdList,
      fileArea: filingData.fileArea,
      fileDate: filingData.fileDate
    })

    return axios.post(basePath + '/batch/toArchiveContract', params)
  },
  //查看用户组
  queryUserGroupById: function(id) {
    return axios.post(basePath + '/userGroup/queryUserGroupById?id=' + id)
  }
}
const userGroup = {
  queryUserGroupExcludeOneself: function(name, id) {
    return axios.post(
      basePath +
        '/userGroup/queryUserGroupExcludeOneself?name=' +
        name +
        '&groupId=' +
        id
    )
  },
  queryUserGroup: function(name) {
    return axios.post(basePath + '/userGroup/queryUserGroup?name=' + name)
  },
  queryUserGroupRel: function(params) {
    return axios.post(basePath + '/userGroup/queryUserGroupRel', params)
  },
  queryUserGroupRelList: function(id) {
    return axios.post(basePath + '/userGroup/queryUserGroupRelList', {
      groupId: id
    })
  },
  deleteUserGroupRel: function(id) {
    return axios.post(basePath + '/userGroup/deleteUserGroupRel?id=' + id)
  },
  createUserGroupRel: function(params) {
    return axios.post(basePath + '/userGroup/createUserGroupRel', params)
  },
  deleteUserGroup: function(id) {
    return axios.post(basePath + '/userGroup/deleteUserGroup?id=' + id)
  },
  createUserGroup: function(params) {
    return axios.post(basePath + '/userGroup/createUserGroup', params)
  },
  updateUserGroup: function() {
    return axios.post(basePath + '/userGroup/updateUserGroup')
  },
  findOrgListByPage: function(id, pageNum, pageSize) {
    return axios.post(
      basePath +
        '/findOrgListByPage?groupId=' +
        id +
        '&pageNum=' +
        pageNum +
        '&pageSize=' +
        pageSize
    )
  },
  findUserListByPage: function(id, pageNum, pageSize) {
    return axios.post(
      basePath +
        '/findUserListByPage?groupId=' +
        id +
        '&pageNum=' +
        pageNum +
        '&pageSize=' +
        pageSize
    )
  }
}
const updateFile = {
  //上传附件
  fileImage: function() {
    return axios.post(basePath + '/contract/common/uploadFile')
  },
  //获取附件信息
  attachment: function(id) {
    return axios.get(basePath + '/attachment/getContractAuditAttachment/' + id)
  },
  //预览合同附件 /contract/common/downloadAttachementFile?id=&fileHash=&fileType=&fileName=
  downloadAttachementFile: function(info) {
    return axios.get(
      basePath +
        '/contract/common/downloadAttachementFile?resultMode=' +
        2 +
        '&id=' +
        info.id +
        '&fileHash=' +
        info.fileHash +
        '&fileType=' +
        info.fileType +
        '&fileName=' +
        info.fileName
    )
  }
}
//签章定位功能 五局定制
const signPosition = {
  //获取签约印章
  getMoulageImageByTemplate: function(type, text, userType) {
    var params = {}
    params.type = type
    params.text = text
    params.userType = userType
    return axios.post(basePath + '/getMoulageImageByTemplate', params)
  },
  //获取签章坐标
  getSubSignpos: function(id) {
    return axios.get(basePath + '/getSubSignpos/' + id)
  },
  //打印功能中 存储mac地址
  savePrintLog: function(mac) {
    return axios.post(basePath + '/savePrintLog/' + mac)
  },
  //下载时存mac地址
  saveDownloadLog: function() {
    return axios.post(basePath + '/saveDownloadLog')
  },
  //五局获取主合同类型接口
  getContractTypeList: function() {
    return axios.post(basePath + '/getContractTypeList?fileNature=' + 0)
  },
  //五局获取新增附属文件获取项目列表/getProjectByContractId
  getProjectByContractId: function(contractId) {
    return axios.get(basePath + '/getProjectByContractId/', contractId)
  },
  //关键字签章 获取关键字
  getKeywordsNumbers: function(id) {
    return axios.get(basePath + '/contract/getKeywordsNumbers/' + id)
  },
  //银联卡校验
  unionCardRevirify: function(params) {
    return axios.post(basePath + '/unionCardRevirify', params)
  }
}

//项目
const project = {
  //项目分类查询不分页
  getProjectType(param) {
    return axios.post(basePath + '/projectType/findAll', param)
  },
  //项目分类分页列表查询
  findListByPage(param) {
    return axios.post(basePath + '/projectType/findListByPage', param)
  },
  //项目分类详情
  projectTypeDetail(param) {
    return axios.post(basePath + '/projectType/view', param)
  },
  //新增项目分类
  projectTypeAdd(param) {
    return axios.post(basePath + '/projectType/add', param)
  },
  //修改项目分类
  projectTypeUpdate(param) {
    return axios.post(basePath + '/projectType/update', param)
  },
  //启用项目分类
  projectTypeEnable(param) {
    return axios.post(basePath + '/projectType/enable/' + param.id)
  },
  //停用项目分类
  projectTypeDisable(param) {
    return axios.post(basePath + '/projectType/disable/' + param.id)
  },
  //删除项目分类
  projectTypeDelete(param) {
    return axios.post(basePath + '/projectType/delete/' + param.id)
  },
  //分页查询项目列表
  projectList(param) {
    let params = new URLSearchParams({
      pageNum: param.pageNum,
      pageSize: param.pageSize,
      projname: param.projname
    })
    return axios.post(basePath + '/projectList', params)
  },
  //项目详情
  projectDetail(param) {
    return axios.post(basePath + '/project/view', param)
  },
  //新增项目
  projectAdd(param) {
    return axios.post(basePath + '/project/add', param)
  },
  //修改项目
  projectUpdate(param) {
    return axios.post(basePath + '/project/update', param)
  },
  //启用项目
  projectEnable(param) {
    return axios.post(basePath + '/project/enable/' + param.id)
  },
  //停用项目
  projectDisable(param) {
    return axios.post(basePath + '/project/disable/' + param.id)
  },
  //删除项目
  projectDelete(param) {
    return axios.post(basePath + '/project/delete/' + param.id)
  }
}

//签署设置
const signSet = {
  //20191216版 签署设置保存 saveSignSettings
  saveSignSettings: function(params) {
    return axios.post(basePath + '/signSet/saveSignSettings', params)
  },
  //获取签署方式
  findList: function(id) {
    let params = { id: id ? id : '' }
    return axios.post(basePath + '/signSet/findList', params)
  },
  //保存签署方式
  saveSignSetting: function(params) {
    return axios.post(basePath + '/signSet/saveSignSetting', params)
  },
  //获取验证码contract/sign/sendVerifyCode
  sendVerifyCode: function(params) {
    return axios.post(basePath + '/contract/sign/sendVerifyCode', params)
  },
  //验证验证码 /contract/sign/checkVerifyCode
  checkVerifyCode: function(params) {
    return axios.post(basePath + '/contract/sign/checkVerifyCode', params)
  },
  //获取 印章图片 /contract/getSealList
  getSealList: function(params) {
    return axios.post(basePath + '/contract/getSealList', params)
  },
  //银联卡认证 personalCertificationForUnionPayBySign
  personalCertificationForUnionPayBySign: function(params) {
    return axios.post(
      basePath + '/personalCertificationForUnionPayBySign',
      params
    )
  },
  //获取签章活体认证二维码
  getQRCodeForSubscirber: function(userId) {
    return axios.post(basePath + '/getQRCodeForSubscirber?subid=' + userId)
  },
  //获取当前签约人认证状态
  querySubRevifyState: function(userId) {
    return axios.post(basePath + '/querySubRevifyState?subid=' + userId)
  },

  checkContractInSign: function(id, version) {
    return axios.get(
      basePath +
        '/contract/checkContractInSign?id=' +
        id +
        '&version=' +
        version
    )
  }
}

//人事合同模块全接口
const personnel = {
  //类型列表 personnel/contractTypeList
  contractTypeList: function(params) {
    return axios.post(basePath + '/personnel/contractTypeList', params)
  },
  //添加合同类型
  contractTypeAdd: function(params) {
    return axios.post(basePath + '/personnel/contractType/add', params)
  },
  //启用 停用 /personnel/contractType/chgStatus
  chgStatus: function(params) {
    return axios.post(basePath + '/personnel/contractType/chgStatus', params)
  },
  //删除 /personnel/contractType/delete/{typeId}
  contractTypeDelete: function(typeId) {
    return axios.post(basePath + '/personnel/contractType/delete/' + typeId)
  },
  //查看文件类型 /personnel/typeInfo/{typeId}
  typeInfo: function(typeId) {
    return axios.post(basePath + '/personnel/typeInfo/' + typeId)
  },
  //修改 /personnel/contractType/edit
  contractTypeEdit: function(params) {
    return axios.post(basePath + '/personnel/contractType/edit', params)
  },
  //查询可用的合同类型 personnel/normalContractTypeList
  normalContractTypeList: function() {
    return axios.post(basePath + '/personnel/normalContractTypeList')
  },
  //模板列表 /personnel/templateList
  templateList: function(params) {
    return axios.post(basePath + '/personnel/templateList', params)
  },
  //添加模板 /personnel/contractTemplate/add
  contractTemplateAdd: function(params) {
    return axios.post(basePath + '/personnel/contractTemplate/add', params)
  },
  //模板启用和禁用  /personnel/contractTemplate/chgState
  contractTemplateChgState: function(params) {
    return axios.post(basePath + '/personnel/contractTemplate/chgState', params)
  },
  //删除模板 /personnel/contractTemplate/delete/{tempId}
  contractTemplateDelete: function(tempId) {
    return axios.post(basePath + '/personnel/contractTemplate/delete/' + tempId)
  },
  //获取模板详情 /personnel/templateInfo/{tempId}
  templateInfo: function(tempId) {
    return axios.post(basePath + '/personnel/templateInfo/' + tempId)
  },
  //修改模板 /personnel/contractTemplate/edit
  contractTemplatEdit: function(params) {
    return axios.post(basePath + '/personnel/contractTemplate/edit', params)
  }
}

const sealManage = {
  //印章管理
  orgSealList(params) {
    return axios.post(
      basePath +
        '/orgLegalAuth/orgSealList?orgid=' +
        params.orgid +
        '&sealType=' +
        params.sealType
    )
  },
  //设置法人章 orgLegalAuth/siteLegal
  siteLegal(params) {
    return axios.post(basePath + '/orgLegalAuth/siteLegal', params)
  },
  //保存是授权法人 orgLegalAuth/saveOrUpdate
  saveOrUpdate(params) {
    return axios.post(basePath + '/orgLegalAuth/saveOrUpdate', params)
  },
  //删除授权法人 orgLegalAuth/deleteById
  orgLegalAuthDeleteById(params) {
    return axios.post(basePath + '/orgLegalAuth/deleteById', params)
  },
  //企业员工设置法人
  siteLegal1(params) {
    return axios.post(basePath + '/orgLegalAuth/siteLegal1', params)
  },
  //企业员工取消法人 orgLegalAuth/deleteById1
  orgLegalAuthDeleteById1(params) {
    return axios.post(basePath + '/orgLegalAuth/deleteById1', params)
  }
}

//云文档设置位置
const cloudPos = {
  //上传至云文档 /api/tools/clouldFile/uploadClouldFile
  uploadClouldFile: function(params) {
    return axios.post(basePath + '/tools/clouldFile/uploadClouldFile', params)
  },
  uploadClouldFileSign: function(params) {
    return axios.post(basePath + '/tools/clouldFile/uploadClouldFileSign', params)
  },
  //获取文档配置 /api/tools/clouldFile/getCloudFileServiceUrl
  getCloudFileServiceUrl: function(params) {
    return axios.get(
      basePath + '/tools/clouldFile/getCloudFileServiceUrl',
      params
    )
  },
  //获取骑缝章坐标 clouldign/initSignParam
  initSignParam(params) {
    return axios.post(basePath + '/clouldign/initSignParam', params)
  },
  //锁定版本 /tools/clouldFile
  lockContract(params) {
    return axios.post(basePath + '/tools/clouldFile/lockContract', params)
  },
  //解锁合同 unlockContract
  unlockContract(params) {
    return axios.post(basePath + '/tools/clouldFile/unlockContract', params)
  },
  //最后签章 clouldign/doSignFinish
  doSignFinish(params) {
    return axios.post(basePath + '/clouldign/doSignFinish', params)
  },
  // /prevContracttoFilePath
  prevContracttoFilePath(params) {
    return axios.post(basePath + '/prevContracttoFilePath', params)
  }
}

export default {
  signPosition,
  updateFile,
  userGroup,
  businessItem,
  sysConfig,
  orgManagement,
  currentUser,
  getGlobalMap,
  getPermissionMap,
  base,
  basePath,
  menu,
  org,
  certification,
  contractTemplate,
  dict,
  contractCommon,
  user,
  log,
  contractAuth,
  coduRule,
  contract,
  syncUser,
  role,
  contractType,
  sms,
  contractSign,
  batch,
  signSet,
  project,
  personnel,
  token,
  sealManage,
  cloudPos
}



// WEBPACK FOOTER //
// ./src/assets/js/api.js